export var HOTSPOT_ACTIVE = 1;
export var HOTSPOT_DETACHED = 2;
export var HOTSPOT_DELETED = 3;
